import { ClipboardList, Scale } from 'lucide-react'
import { Link } from './nav'
import type { Bug } from '../data/projectTypes'
import { taskDetailUrl } from '../lib/taskDetailPath'
import { useGetBugJudgeActionsQuery } from '../services/taskActionsApi'

// Mounted only in admin mode, so ordinary readers never request admin provenance.
export default function BugJudgeLinks({ bug }: { bug: Bug }) {
  const { currentData, isFetching, isError, refetch } = useGetBugJudgeActionsQuery(bug.id)
  return (
    <nav className="bug-report__judge-links" aria-label="Bug filing provenance">
      {bug.task_id && (
        <Link to={taskDetailUrl(bug.project_id, bug.task_id)} className="bug-report__task-link"
          data-testid="bug-task-link" data-analytics-event="bug-task-link">
          <ClipboardList size={14} aria-hidden="true" />
          View the task that generated this bug report
        </Link>
      )}
      {currentData?.actions.map(action => (
        <Link key={action.stage} to={`${taskDetailUrl(action.project_id, action.task_id)}#action-${action.action_id}`}
          className="bug-report__task-link" data-testid={`bug-${action.stage}-judge-link`}>
          <Scale size={14} aria-hidden="true" />
          {action.label}
        </Link>
      ))}
      {isFetching && <span role="status">Loading judge actions…</span>}
      {isError && <span role="alert">Could not load judge actions. <button type="button" onClick={() => void refetch()}>Retry</button></span>}
      {!isFetching && !isError && currentData?.actions.length === 0 && <span>No recorded judge actions available.</span>}
    </nav>
  )
}
